import { render } from "./BelongsToColumn.vue?vue&type=template&id=98193b48"
import script from "./BelongsToColumn.vue?vue&type=script&lang=js"
export * from "./BelongsToColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__